import React, {Component} from "react"
import styled from "styled-components"
import media from "../../global/media"

import {Card} from "../../Layout"

const StyledCard = styled(Card)`
  ${media.phoneLandscape`
    border-radius: 0;
  `}
`

class AccountSideBar extends Component {
  render() {
    return (
      <StyledCard tiny noBorder {...this.props} />
    )
  }
}

export default AccountSideBar
